export const SEARCH_FORM_SUBMIT = 'STUDENT.SURVEY.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STUDENT.SURVEY.SORT_CHANGE';
export const PAGE_CHANGE = 'STUDENT.SURVEY.PAGE_CHANGE';
export const FETCH_LIST = 'STUDENT.SURVEY.FETCH_LIST';
export const FETCH_ONE = 'STUDENT.SURVEY.FETCH_ONE';
export const CLEAR_ONE = 'STUDENT.SURVEY.CLEAR_ONE';
